'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeVisibilityChangeListener = removeVisibilityChangeListener;

var _getBrowserPrefix = require('./getBrowserPrefix');

var _getVisibilityChangeNamespace = require('./getVisibilityChangeNamespace');

var _wrapVisibilityCallback = require('./wrapVisibilityCallback');

function removeVisibilityChangeListener(callback) {
  var prefix = (0, _getBrowserPrefix.getBrowserPrefix)();
  if (prefix) {
    var visibilityChange = (0, _getVisibilityChangeNamespace.getVisibilityChangeNamespace)(prefix);
    document.removeEventListener(visibilityChange, (0, _wrapVisibilityCallback.wrapVisibilityCallback)(callback));
  } else {
    window.removeEventListener('focus', (0, _wrapVisibilityCallback.wrapVisibilityCallback)(callback));
    window.removeEventListener('blur', (0, _wrapVisibilityCallback.wrapVisibilityCallback)(callback));
  }
}